import React, { useCallback, useMemo } from 'react';

import { MoreButtonCDS } from '@sharedCR/coreDesignSystem/Buttons';
import { EditPenIcon } from '@sharedCR/coreDesignSystem/icons';
import MenuPopoverCDS from '@sharedCR/coreDesignSystem/MenuPopoverCDS';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import usePopover from 'hooks/usePopover';

const ActionButton = ({ row, onEdit, disabled = false }) => {
  const { anchorEl, onSetAnchorElement, onClearAnchorElement } = usePopover();

  const onClickEdit = useCallback(() => {
    onClearAnchorElement();
    onEdit(row);
  }, [onClearAnchorElement, onEdit, row]);

  const items = useMemo(
    () => [{ text: 'Edit', onClick: onClickEdit, icon: <EditPenIcon size={IconSize[20]} /> }],
    [onClickEdit],
  );

  return (
    <>
      <MoreButtonCDS disabled={disabled} isSelected={!!anchorEl} onClick={onSetAnchorElement} />

      <MenuPopoverCDS anchorEl={anchorEl} items={items} onClose={onClearAnchorElement} />
    </>
  );
};

ActionButton.propTypes = {
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ActionButton;
